import { TestDefinitionService } from "../../../data/services";
import { TestDefinition } from "../../../data/models/test-definition";
import { IOperationServiceConfig } from '../../../model-repository'
import { JsonApiProcessor } from '../../../data/services'


export const TestDefinitionConfig: IOperationServiceConfig<TestDefinition> = {
  service: TestDefinitionService,
  deps: [JsonApiProcessor],
  endpoint: 'exams/test_definitions?filter[user-id]=:user_id',
  model: TestDefinition,
  mappings: [
    {
      classType: 'TestDefinition',
      jsonType: 'test-definitions',
      propertyMapping: {
        notes: {
          isCollection: false
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/operation/test-definition.config.ts